import React from 'react';
import { Link } from 'react-router-dom';
import { pwaTrueEmptySotHref } from './createPwaJob';
import { PWA_JOBS_SOT_VALUES, pwaJobsSotExitHref, pwaJobsSotHref } from './ordersSurface';

const SOT_LABELS: Record<string, string> = {
    empty: 'EMPTY',
    error: 'ERROR',
    offline: 'OFFLINE',
    pending: 'PENDING · EMPTY',
    'pending-handoff': 'PENDING · HANDOFF',
    handoff: 'HANDOFF · ACTIVE',
    'complete-handoff': 'COMPLETE · HANDOFF',
};

type Props = {
    active?: string | null;
    search?: string;
};

const JobsSotSwitcher = ({ active = null, search = '' }: Props) => (
    <nav className="jobs-sot-switcher" data-testid="jobs-sot-switcher" aria-label="PWA jobs SoT">
        {PWA_JOBS_SOT_VALUES.map((surface) => (
            <Link
                key={surface}
                className={`jobs-sot-link${active === surface ? ' is-active' : ''}`}
                to={pwaJobsSotHref(surface, search)}
            >
                {SOT_LABELS[surface]}
            </Link>
        ))}
        <Link className="jobs-sot-link" to={pwaTrueEmptySotHref('walk')}>
            TRUE EMPTY · WALK
        </Link>
        <Link className="jobs-sot-link" to={pwaJobsSotExitHref()}>
            Exit SoT
        </Link>
    </nav>
);

export default JobsSotSwitcher;
